// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c1-K","fullView":"styles_fullView__R9HkC"};